module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page bg-primary"
  }, [(_vm.loggedIn) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Kies een Wachtwoord")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "name": "newPassword",
      "placeholder": "Nieuw Wachtwoord"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-alert-danger"
  }, [_vm._v(_vm._s(_vm.error.code))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ChangePassword($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("TOEPASSEN")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.warning) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Er ging iets fout")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [(_vm.$store.state.core.user) ? _c('p', [_vm._v("Je hebt je account nog niet geactiveerd. "), _c('br'), _vm._v(" Dit kan met de link die we naar " + _vm._s(_vm.$store.state.core.user.email) + " hebben verzonden.")]) : _c('p', [_vm._v("Je hebt je account nog niet geactiveerd. "), _c('br'), _vm._v(" Dit kan met de link die we naar je email-adress hebben verzonden.")])]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ChangeAccount($event)
      }
    }
  }, [_vm._v("Ander account")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Er ging iets fout")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ChangeAccount($event)
      }
    }
  }, [_vm._v("Ander account")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-margin"
  }, [_c('p', {
    staticClass: "uk-text-danger"
  }, [_vm._v("De link die je hebt gebruikt is niet correct. "), _c('br'), _vm._v(" Gebruik de link die je ontvangen hebt via email.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e4dda22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/pages/FirstLogin.vue
// module id = 512
// module chunks = 1